import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@fec/frontend/elements/buttons/button/button';
import './show-more-bar.scss';

const ShowMoreBar = React.forwardRef(
  (
    {
      styleModifier,
      showMoreText,
      showMoreTextMobile,
      showMoreModifier,
      renderBackToTop = true,
      backToTopLink = '#skiplink__contentlink',
      backToTopText,
      // react-only props
      onClick = () => {},
      hasMore = true,
      iconDirection = 'down',
      loadMoreButtonDisabled = false,
      loadMoreButtonRef,
    },
    ref,
  ) => {
    return (
      <div
        className={classNames(
          'show-more-bar',
          'js-show-more-bar',
          styleModifier,
        )}>
        {hasMore && (
          <Button
            styleModifier={classNames(
              'button--white',
              'button--mixed-case',
              'button--link-text-color',
              'button--no-spacing',
              'show-more-bar__child',
              'show-more-bar__child--grow',
              'js-show-more-button',
              showMoreModifier,
            )}
            svgIcon={
              iconDirection === 'up'
                ? 'svg-icon--arrow-up-red'
                : 'svg-icon--arrow-down-red'
            }
            buttonText={showMoreText}
            buttonTextMobile={showMoreTextMobile}
            onClick={onClick}
            disabled={loadMoreButtonDisabled}
            ref={loadMoreButtonRef}
          />
        )}

        {renderBackToTop && (
          <Button
            styleModifier="button--white button--icon-only button--no-spacing"
            className="show-more-bar__child"
            svgIcon="svg-icon--arrow-up"
            href={backToTopLink}
            screenReaderText={backToTopText}
          />
        )}
      </div>
    );
  },
);

ShowMoreBar.propTypes = {
  styleModifier: PropTypes.string,
  showMoreText: PropTypes.string,
  showMoreTextMobile: PropTypes.string,
  renderBackToTop: PropTypes.bool,
  backToTopLink: PropTypes.string,
  backToTopText: PropTypes.string,
  onClick: PropTypes.func,
  hasMore: PropTypes.bool,
  showMoreModifier: PropTypes.string,
  loadMoreButtonDisabled: PropTypes.bool,
  iconDirection: PropTypes.oneOf(['up', 'down']),
};

export default ShowMoreBar;
